import { gql } from 'graphql.macro';

export const getReleaseNotesTemplate = gql`
    query releaseNotes {
        releaseNotes {
            _id
            version
            organizationType
            isPublished
            createdAt
            translations {
                language
                content
            }
        }
    }
`;

export const getNextReleaseNoteVersionTemplate = gql`
    query nextReleaseNoteVersion {
        nextReleaseNoteVersion
    }
`;
